import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ITHORStakingStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTSStakingAPRConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorswap', 'thor_staking_stats', timeframe)) as ITHORStakingStats[]
	const series1 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.VTHOR_APR_PCT }
	})
	const series2 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.UTHOR_APR_PCT }
	})
	const series3 = chartData.map((element: ITHORStakingStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.YTHOR_APR_PCT }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'vThor',
			type: 'line',
			seriesGroup: '[%]',
			color: 'orange',
			unitSymbol: '%'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'uThor',
			type: 'line',
			seriesGroup: '[%]',
			color: 'green',
			unitSymbol: '%'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'yThor',
			type: 'line',
			seriesGroup: '[%]',
			color: '#0ffc03',
			unitSymbol: '%'
		}
	]
	return { config: config, latestValue: (series1[series1.length - 1].y + series2[series2.length - 1].y + series3[series3.length - 1].y) / 3, latestValueDate: series2[series2.length - 1].x }
}

const TSStakingAPR = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTSStakingAPRConfig, '1w')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="THOR Staking APR"
			chartDesc="THOR Staking APR over time. For each day average total staking balance and average yield from last 30 days is calculated, divided and multiplied by 365 to extrapolate yearly earning percentage."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="7a055efe-72db-4ee0-b542-d4fa0541c84d"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}
export default TSStakingAPR
